var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement",on:{"click":_vm.toAgreement}},[_vm._v("《Privacy Agreement》")])
}
var staticRenderFns = []

export { render, staticRenderFns }